import { Routes, Route } from 'react-router';
import { designSevenPagePath } from '@legacy/designSevenPagePath';
import {
  NotFound,
  NewNavigationEntry,
  FrontPageSettings,
} from '@legacy/screens/PageSettings/screens';

export const PageSettingsRouter = () => (
  <Routes>
    <Route path={'/'} element={<NewNavigationEntry />} />
    <Route
      path={designSevenPagePath.pageSettings.frontPage}
      element={<FrontPageSettings />}
    />
    <Route
      path={designSevenPagePath.pageSettings.frontPage}
      element={<FrontPageSettings />}
    />
    <Route
      path={designSevenPagePath.pageSettings.notFound}
      element={<NotFound />}
    />
  </Routes>
);
